import { Alert } from "antd"
import { useContext } from "react"
import { UserContext } from "../Context/UserContext"

const Dashboard = () => {
    const [user] = useContext(UserContext)
    return (
        <Alert message={`Selamat datang ${user.name}`}/>
    )
}

export default Dashboard